import React, { useState, useContext } from "react";
import {
  getSTAddress,
  getBTAddress,
  isValidChinesePhoneWithCountryCode,
} from "Utils/addressUtils";
import { isValidEmail } from "Utils/common";
import { USER_TYPE } from "Utils/constant";
import { AppContext } from "../../../store";


const MShippingAddress: React.FC<{
  errMsg?: {
    stContact?: string | undefined;
    stContactPhone?: string | undefined;
    billContact?: string | undefined;
    billContactPhone?: string | undefined;
  };
  setErrMsg?: (value: any) => void;
  selectedST: any;
  stContact: string;
  setStContact: (value: string) => void;
  stContactPhone: string;
  setStContactPhone: (value: string) => void;
  setShowSTSelector: (value: boolean) => void;
  errMsg2?: string;
  selectedBT: any;
  billContact: string;
  setBillContact: (value: string) => void;
  billContactPhone: string;
  setBillContactPhone: (value: string) => void;
  primaryEmail: string;
  emails: string[];
  setEmails: (emails: string[]) => void;
  onAddressChangeClick: (type?: any) => void;
}> = (props) => {
  const { loginState } = useContext(AppContext);
  const isEmployee = loginState?.userType === USER_TYPE.EMPLOYEE;
  const {
    stContact,
    setStContact,
    stContactPhone,
    setStContactPhone,
    selectedST,
    errMsg,
    setErrMsg,
    billContact,
    setBillContact,
    billContactPhone,
    setBillContactPhone,
    selectedBT,
    emails,
    setEmails,
    primaryEmail,
    onAddressChangeClick
  } = props;
  const [addEmail, setAddEmail] = useState(false);
  const handleStContact = (e: React.ChangeEvent<HTMLInputElement>) => {
    console.log(e.target.value);
    setStContact(e.target.value);
    if (e.target.value && errMsg?.stContact) {
      setErrMsg && setErrMsg({ ...errMsg, stContact: "" });
    }
  };

  const handleStContactPhone = (e: React.ChangeEvent<HTMLInputElement>) => {
    console.log(e.target.value);
    const phone = e.target.value;
    setStContactPhone(phone);
    if (!setErrMsg) return;
    const normalizedPhone = phone.replace(/[()\uFF08\uFF09]/g, "").trim(); // 兼容中英文括号
    if (phone && !isValidChinesePhoneWithCountryCode(normalizedPhone)) {
      setErrMsg({ ...errMsg, stContactPhone: "注意：您输入的联系方式格式可能不对，若您确认无误，请忽略" });
    } else {
      setErrMsg({ ...errMsg, stContactPhone: "" });
    }
  };
  const handleBtContact = (e: React.ChangeEvent<HTMLInputElement>) => {
    console.log(e.target.value);
    setBillContact(e.target.value);
    if (e.target.value && errMsg?.billContact) {
      setErrMsg && setErrMsg({ ...errMsg, billContact: "" });
    }
  };
  const handleBtContactPhone = (e: React.ChangeEvent<HTMLInputElement>) => {
    console.log(e.target.value);
    const phone = e.target.value;
    setBillContactPhone(phone);
    if (!setErrMsg) return;
    const normalizedPhone = phone.replace(/[()\uFF08\uFF09]/g, "").trim(); // 兼容中英文括号
    if (phone && !isValidChinesePhoneWithCountryCode(normalizedPhone)) {
      setErrMsg({ ...errMsg, billContactPhone: "注意：您输入的联系方式格式可能不对，若您确认无误，请忽略" });
    } else {
      setErrMsg({ ...errMsg, billContactPhone: "" });
    }
  };
  const handleAddEmail = () => {
    setAddEmail(!addEmail);
  };
  if (!selectedST) {
    return null;
  }
  if (!selectedBT) {
    return null;
  }

  return (
    <div>
      <p
        style={{
          margin: "5px 0px 15px 0",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <span className={"shipTo"}>
          <span style={{ fontWeight: "bold" }}>收件信息:</span>
          {selectedST.accountNumber}
          {!isEmployee && <span onClick={onAddressChangeClick} className={'addressLink'}>更改</span>}
        </span>{" "}
        {(selectedST.prePaymentAccount === true ||
          selectedBT.prePaymentAccount === true) && (
          <span className={"badge"}>预付款</span>
        )}
      </p>

      <p className={"address"} style={{ marginTop: "10px" }}>
        {getSTAddress(selectedST)}
      </p>
      <div>
        <p className={"shipTo"}>
          <span style={{ fontWeight: "bold" }}>{"联系人姓名"}: </span>{" "}
          <input
            type="text"
            className={"shipToName"}
            id="shiptoname"
            name="shiptoname"
            value={stContact}
            onChange={(e) => handleStContact(e)}
            // onBlur={(e) => checkShipToNameChange(e)}
          />
        </p>
        {errMsg?.stContact && (
          <div style={{ color: 'red' }}>{errMsg?.stContact}</div>
        )}
        <p className={"shipTo"}>
          <span style={{ fontWeight: "bold" }}> {"电话号码"}:</span>{" "}
          <span className={"prefixSpan"}>{"+86"}</span>
          <input
            type="text"
            className={"shipToName"}
            id="shiptono"
            name="shiptono"
            value={stContactPhone}
            onChange={(e) => handleStContactPhone(e)}
            // onBlur={(e) => checkShipToNoChange(e)}
          />
        </p>
        {errMsg?.stContactPhone && (
          <div style={{ color: 'red' }}>{errMsg?.stContactPhone}</div>
        )}
      </div>
      <div className={"devider"}></div>
      <div className={"availability"}>
        <span className={"shipTo"}>
          <span style={{ fontWeight: "bold" }}>{"账单/发票寄送地址"}:</span>
          {selectedBT.accountNumber}
          {/* {props.ableChangeAddress && <a onClick={changeAddress} className={'addressLink'} > {f('ADDRESS_CHANGE')}</a>} */}
        </span>
      </div>
      <div className={"shipTo"}>
        <span style={{ fontWeight: "bold" }}>{"机构名称"}:</span>{" "}
        {selectedBT.companyOrInstitution}
      </div>
      <div className={"address"} style={{ marginTop: "5px" }}>
        {getBTAddress(selectedBT)}
      </div>
      <div>
        <p className={"shipTo"}>
          <span style={{ fontWeight: "bold" }}>{"联系人姓名"}: </span>{" "}
          <input
            type="text"
            className={"shipToName"}
            id="billtoname"
            name="billtoname"
            value={billContact}
            onChange={(e) => handleBtContact(e)}
            // onBlur={(e) => checkBillToNameChange(e)}
          />
        </p>
        {errMsg?.billContact && (
          <div style={{ color: 'red' }}>{errMsg?.billContact}</div>
        )}
        <p className={"shipTo"}>
          <span style={{ fontWeight: "bold" }}> {"电话号码"}:</span>{" "}
          <span className={"prefixSpan"}>{"+86"}</span>
          <input
            type="text"
            className={"shipToName"}
            id="billtono"
            name="billtono"
            value={billContactPhone}
            onChange={(e) => handleBtContactPhone(e)}
            // onBlur={(e) => checkBillToNoChange(e)}
          />
        </p>
        {errMsg?.billContactPhone && (
          <div style={{ color: 'red' }}>{errMsg?.billContactPhone}</div>
        )}
      </div>
      <div className={"devider"}></div>
      <div className={"availability"}>
        <span className={"email"}>
          {" "}
          {"订单信息将发送至"} <br /> {primaryEmail}
        </span>
      </div>
      <span className={"addEmail"} onClick={handleAddEmail}>
        {"+额外的电子邮件"}
      </span>
      {addEmail && (
        <div
          className={"qunatityContainer"}
          style={{ border: "none", margin: "0px", padding: "0px" }}
        >
          <p className={"selectMoreTextHeader"}>{"输入电子邮件"}</p>
          <input
            className={"quantityInputBox"}
            type="email"
            placeholder={"邮件"}
            autoFocus={true}
            value={emails[0]}
            maxLength={50}
            onChange={(e) => {
              setEmails([e.target.value]);
            }}
          ></input>
        </div>
      )}
     {(emails[0] && !isValidEmail(emails[0])) && <div style={{ color: 'red' }}>无效格式</div>}
    </div>
  );
};

export default MShippingAddress;
